<script>
import appConfig from '@src/app.config'

export default {
  data() {
    return { appVersion: appConfig.version }
  },
}
</script>
<template>
  <!-- Footer Start -->
  <div class="container copyright position-absolute">
    <div class="row">
      <div class="col-12 pl-4">
        <small>
          &copy;2014-{{ new Date().getFullYear() }} <br />
          All Rights Reserved. <br />
          Version: {{ appVersion.replace('v', '') }}
        </small>
      </div>
      <div id="payment-note" class="col-12 pl-4 mt-3">
        <p class="text-muted font-size-14 font-weight-bold"> We accept: </p>
        <img src="/assets/logos/card-logos.png" />
      </div>
    </div>
  </div>
  <!-- end Footer -->
</template>
